import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { cn } from "@/utils/helpers";
const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>((t0, ref) => {
  const $ = _c(11);
  let className;
  let props;
  let type;
  if ($[0] !== t0) {
    ({
      className,
      type,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = type;
  } else {
    className = $[1];
    props = $[2];
    type = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== props || $[7] !== ref || $[8] !== t1 || $[9] !== type) {
    t2 = <input type={type} className={t1} ref={ref} {...props} />;
    $[6] = props;
    $[7] = ref;
    $[8] = t1;
    $[9] = type;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
});
Input.displayName = "Input";
export { Input };